import { useState, useEffect } from 'react'
import { Modal } from '../ui'
import PhoneSignInForm from './PhoneSignInForm'

interface AuthModalProps {
  isOpen: boolean
  onClose: () => void
  defaultMode?: 'signin'
}

type AuthMode = 'signin' | 'reset'

const AuthModal = ({ isOpen, onClose, defaultMode = 'signin' }: AuthModalProps) => {
  const [authMode, setAuthMode] = useState<AuthMode>(defaultMode)

  useEffect(() => {
    setAuthMode(defaultMode)
  }, [defaultMode])

  const handleClose = () => {
    setAuthMode(defaultMode)
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="md"
      showCloseButton={true}
    >
      <div className="p-1 sm:p-2">
        {authMode === 'signin' && (
          <PhoneSignInForm />
        )}
      </div>
    </Modal>
  )
}

export default AuthModal